import { z } from "zod";

export const PRODUCT_STOCK_ADJUSTMENT_KIND = "product-balance-adjustment-v1";
export const productStockAdjustmentSchema = z.object({
  requestId: z.string().uuid(),
  expectedQuantity: z.number().int().safe(),
  newQuantity: z.number().int().safe().nonnegative(),
  reason: z.string().trim().min(1).max(500),
}).strict().refine((v) => Number.isSafeInteger(v.newQuantity - v.expectedQuantity), {
  message: "Quantity difference exceeds the supported range", path: ["newQuantity"],
});
export type ProductStockAdjustmentInput = z.infer<typeof productStockAdjustmentSchema>;
export interface ProductStockAdjustmentDto {
  id: string;
  moveNo: string;
  productId: string;
  beforeQuantity: number;
  afterQuantity: number;
  delta: number;
  reason: string;
  actorId: string;
  actorName: string;
  movedAt: number;
}
export interface ProductStockHistoryDto {
  stockQuantity: number;
  adjustments: ProductStockAdjustmentDto[];
}

/** Một lô của sản phẩm trong Kho & LOT (kho còn dùng), cho trang Tồn kho của sản phẩm. */
export interface ProductLotDto {
  kind: string;
  lotNumber: string;
  unit: string;
  warehouseCode: string;
  warehouseName: string;
  location: string;
  onHand: number;
  available: number;
  /** Chờ kiểm hàng nhập (IQC) hoặc đang chuyển kho. */
  pending: number;
  rejected: number;
  /** Chỉ có khi được xem giá vốn / nhà cung cấp. */
  supplierName: string | null;
}
